import React from "react";
import { getTransactionStatusConfig } from "../utils/statusLookup";

export interface TransactionStatusBadgeProps {
  status?: string | null;
  className?: string;
}

export const TransactionStatusBadge: React.FC<TransactionStatusBadgeProps> = ({
  status,
  className = "",
}) => {
  const config = getTransactionStatusConfig(status);

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[12px] font-medium ${config.bg} ${config.text} ${className}`.trim()}
    >
      {config.label}
    </span>
  );
};
